import { Schema } from "../redux/constants/OrdersPage/order";

import { PhoneCountry, validatePhone } from "./validatePhone";

export function initValidator(schema: Schema) {
	const validator = {};

	Object.keys(schema).forEach((key) => {
		validator[key] = true;
	});

	return validator as Record<keyof Schema, boolean>;
}

export interface ShouldValidateOrderForm {
	points?: number;
	phone?: boolean;
	country?: PhoneCountry;
}

export function validateOrderForm(
	form: Schema,
	options: ShouldValidateOrderForm = {},
) {
	const should = {
		points: 1,
		phone: true,
		...options,
	};
	const { country } = options;

	const phones = form.additionalPhones || [];
	const points = form.points || [];
	const normalacyArr = [...points].filter((item) => {
		if (!item) return false;
		if (!item.coordinates.lat) return false;
		if (!item.coordinates.lng) return false;
		return true;
	});

	const isValidPhones = phones.length
		? [...phones]
				.filter((item) => {
					if (!item) return false;
					return true;
				})
				?.map((item) => validatePhone(item, country))
				?.every((item) => item === true)
		: true;

	const isValid = form?.phone ? validatePhone(form.phone, country) : false;
	const isPointsValid = Boolean(normalacyArr?.length >= should.points);
	const existFirst = normalacyArr.find((item) => item.id === 1);

	return {
		...initValidator(form),
		phone: should.phone ? isValid : true,
		points: isPointsValid && !!existFirst,
		additionalPhones: should.phone ? isValidPhones : true,
	};
}
